import React, { useCallback, useContext } from 'react';

import { UserContext } from '../../user.context';
import UserForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(UserContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <UserForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
